module.exports = __webpack_public_path__ + "static/img/img_solar.f397e90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img_solar.png
// module id = vaS2
// module chunks = 1